import { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../../components/general/ProgressComponent";
import {
    ADMIN_ID,
    GET_MEDICAITON_OVERVIEW_LIST,
} from "../../../env";
import {
    getRecords,
    isSuccess,
} from "../../../helper/helper";
import moment from "moment";

function MedicationOverview({ staffHeadingBlock }) {
    const [isLoading, setIsLoading] = useState(false);
    const [userData, setRecords] = useState([]);
    const isMounted = useRef(true);

    useEffect(() => {
        const fetchAllRecords = async () => {
            try {
                setIsLoading(true);

                const response = await getRecords(
                    GET_MEDICAITON_OVERVIEW_LIST,
                    { staffUserId: ADMIN_ID }
                );

                if (isMounted.current && response?.status === isSuccess) {
                    setRecords(response?.data || []);
                }
            } catch (error) {
                console.error("Medication fetch error:", error);
            } finally {
                isMounted.current && setIsLoading(false);
            }
        };

        fetchAllRecords();

        return () => {
            isMounted.current = false;
        };
    }, []);

    const columns = [
        {
            name: "Service User",
            selector: row => (
                <span className="usersNameInfo">
                    <span className="userInfo">
                        <span className="nameBlock">
                            {row?.suFirstMiddleName} {row?.suLastName}
                        </span>
                    </span>
                </span>
            ),
            width: "25%",
        },
        {
            name: "Medication Detail",
            selector: row => (
                <span>
                    {row?.medicationName}
                    <br />
                    <small>No of Doses: {row?.noOfDoses}</small>
                </span>
            ),
            wrap: true,
            width: "35%",
        },
        {
            name: "Status",
            selector: row => row?.status,
            width: "15%",
            center: true,
        },
        {
            name: "Schedule",
            selector: row => (
                <span>
                    Date: {moment(row?.date).format("DD/MM/YYYY")}
                    <br />
                    Time: {row?.startTime}
                </span>
            ),
        },
    ];

    return (
        <>
            <h4>{staffHeadingBlock}</h4>
            <div className="dataTableWrapper">
                <DataTable
                    className="maxWidthTable maxWidthTableRowWidth"
                    columns={columns}
                    data={userData}
                    fixedHeader
                    fixedHeaderScrollHeight="340px"
                    highlightOnHover
                    responsive={true}
                    progressPending={isLoading}
                    progressComponent={<ProgressComponent />}
                />
            </div>
        </>
    );
}

export default MedicationOverview;
